import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { KeyValuePair } from "../../commonInterfaces";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import React from "react";

export default class ProjetPlan extends React.Component<ProjetPlanProps, any>{
    private gridOptions;
    private NEW_ID = "new";
    private DELETE_ID = "delete";
    constructor(props: ProjetPlanProps) {
        super(props)
        this.setOptions();
    }

    private setOptions = () => {
        this.gridOptions = {
            columns: [
                {
                    type: "textBox",
                    field: "Beschreibung",
                    title: Helper.getTranslation("Field.Einsatz.projnr"),
                    width: 150,
                    readonly: true
                },
                {
                    type: "textBox",
                    field: "Bemerkung",
                    title: Helper.getTranslation("Field.Adresse.wvvorhandenbemerkung"),
                    width: 250
                }
            ]
        };
    }

    private update = (data: ProjectInfo[]) => {
        this.props.onChange(this.props.field, data, data)
    }

    private onValueChange = (action, fieldName, dataItems: ProjectInfo[]) => {
        const item = dataItems[0];
        let data: ProjectInfo[] = JSON.parse(JSON.stringify(this.props.value));
        switch (action) {
            case "add":
                data.push(item)
                break;
            case "itemchange":
                const index = data.findIndex(f => f.Beschreibung == item.Beschreibung);
                data[index][fieldName] = item[fieldName]
                break;
            default:
                return;

        }
        this.update(data);
    }

    private createNewItem = () => {
        return new Promise<ProjectInfo>((resolve, reject) => {
            const dynamicSearchUrl = Config.baseUrl + "DynamicSearch/Project";
            const sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl);
            sheet.bind(SheetEventType.RowClicked, (projNr) => {
                const item = this.props.value.find(f => f.Beschreibung == projNr)
                if (Helper.hasValue(item)) {
                    NotificationHelper.showWarningMessage("'{x}' ist bereits vorhanden".replace("{x}", projNr))
                    resolve(null);
                } else {
                    resolve( {
                        Bemerkung: null,
                        Beschreibung: projNr,
                        Zaehler: this.props.value.length + 1
                    });
                }
            });
        })
        

    }

    private handleButtonClick = async (params: InGridButtonClickParams) => {
        const { id, actions, selectedItems } = params;
        switch (id) {
            case this.NEW_ID:
                const item = await this.createNewItem();
                if (Helper.hasValue(item)) {
                    actions.add(item);
                }
                break;
            case this.DELETE_ID:
                const isOk = await DialogHelper.confirm("Wollen Sie die ausgewählten Elemente wirklich löschen?")
                if (isOk) {
                    actions.deleteSelected(false);
                    const data = this.props.value.filter(f1 => selectedItems.findIndex(f2 => f1.Beschreibung == f2.Beschreibung) == -1);
                    this.update(data);
                }
                break;
        }
    }

    render() {

        const buttons: Array<InGridToolBarButton> = [
            {
                type: ToolBarInGridButtonType.CUSTOM,
                id: this.NEW_ID,
                caption: Helper.getTranslation("Standard.Neu"),
                enabled: () => true,
                iconClass: "k-i-plus",
                useContextMenu: true
            },
            {
                type: ToolBarInGridButtonType.CUSTOM,
                id: this.DELETE_ID,
                caption: Helper.getTranslation("Standard.Loeschen"),
                enabled: (p) => p.hasSelection,
                iconClass: "k-i-trash",
                useContextMenu: true
            }
        ];


        let schema = new Schema();
        schema.Id = "Beschreibung";
        return (
            <div style={{ height: "500px" }}>
                <EditableGrid data={this.props.value}
                    id={"projectPlan"}
                    schema={schema}
                    gridOptions={this.gridOptions}
                    editable={!this.props.entity.UserHasRole}
                    onDataChanged={this.onValueChange}
                    validatable={false}
                    groupable={false}
                    filterable={true}
                    buttons={buttons}
                    onButtonClick={this.handleButtonClick}
                    {...this.props}
                />
            </div>
        )
    }
}

interface ProjetPlanProps {
    value: ProjectInfo[];
    onChange: (field, value, dataItem) => void;
    entity: { UserHasRole: boolean };
    field: any;

}

interface ProjectInfo {
    Bemerkung: string;
    Beschreibung: string;
    Zaehler: number;
}